import React, { useContext, useEffect, useState } from "react";
import { Helmet } from "react-helmet";
import trans, { isRTL } from "../../utils";
import BreadCrumb from "../Header/SecondHeader";
import usePermission from "../../hooks/usePermission";
import { popupcontext } from "../../context/Popupscontext";
import Button from "../Helpers/Button/Button";
import { useNavigate } from "react-router-dom";
import { filtrationcontext } from "../../context/Filtercontext";
import { useGetAllPOIsQuery } from "../../Redux/service/POIS/POIs";
import { Tag } from "antd";
import Actions from "../antd/Table/Actions";
import AntdTable from "../antd/Table/Table";
import POIsHead from "../POIs/POIsParts/POIsHeader";
import ProjectsetupHeader from "./ProjectsetupHeader";
import ProjectsetupForm from "./ProjectsetupForm";

export default function Projectsetup() {
	const [currentPage, setCurrentPage] = useState(1);
	const navigate = useNavigate();
	const {
		handleShow,
		setEdited,
		setForm,
		deleteItem,
		setDeleteItem,
		reloadData,
		setReloadData,
		setcurrentPOIId,
	} = useContext(popupcontext);
	const {
		limit,
		setLimit,
		setSort: SetSortFilter,
		searchQuery,
		setSearchQuery,
	} = useContext(filtrationcontext);
	const [sort, setSort] = useState({
		by: "",
		order: "",
	});

	const {
		data: ListPOISdata,
		isLoading,
		refetch,
	} = useGetAllPOIsQuery(
		{
			page: currentPage,
			limit: limit,
			status: "true",
			search: searchQuery,
			sortby: sort.by,
			sortorder: sort.order,
			queryString: "&type=project",
		},
		{
			skip: !currentPage || !limit,
			refetchOnMountOrArgChange: true,
		}
	);
	useEffect(() => {
		return () => {
			SetSortFilter({ type: "", value: "" });
			setSearchQuery("");
		};
	}, [SetSortFilter, setSearchQuery]);

	useEffect(() => {
		setCurrentPage(1);
	}, [searchQuery]);

	useEffect(() => {
		localStorage.setItem("page", currentPage);
	}, [currentPage]);
	const handleTableChange = (pagination, filters, sorter) => {
		if (sorter.order) {
			setSort({
				by: sorter.field,
				order: sorter.order === "ascend" ? "asc" : "desc",
			});
		} else {
			setSort({
				by: "",
				order: "",
			});
		}
	};
	useEffect(() => {
		if (deleteItem.condition === true && deleteItem.value === "pois") {
			refetch();
			if (ListPOISdata?.data.length === 1 && currentPage > 1) {
				setCurrentPage(currentPage - 1);
				localStorage.setItem("page", currentPage);
			}
			setDeleteItem({ condition: null, value: null });
		}
	}, [
		currentPage,
		deleteItem.condition,
		deleteItem.value,
		refetch,
		setDeleteItem,
		ListPOISdata?.data,
	]);
	useEffect(() => {
		if (reloadData) {
			refetch();
			setReloadData(false);
		}
	});
	const { create, edit, delete: canDelete } = usePermission("QAQCPROJECTSETUP");
	const projectTypeTagColor = {
		buildings: "blue",
		infrastructure: "purple",
		roads: "gold",
		MEP: "cyan",
		mixedUse: "green",
	};
	const projectStatusTagColor = {
		active: "green",
		onHold: "orange",
		completed: "success", // or "blue"
		planningPhase: "processing",
	};

	const POIsColumn = [
		{
			title: trans("Project Name"),
			dataIndex: "name",
			width: 200,
			sorter: true,
			fixed: !isRTL ? "left" : undefined,
			render: (name) => (
				<span className={"table-element-name ps-0"}>{name}</span>
			),
		},
		{
			title: trans("Code"),
			dataIndex: "code",
			fixed: !isRTL ? "left" : undefined,
			width: 150,
			render: (code) => <span>{code ? code : "- - - - -"}</span>,
		},
		{
			title: trans("Type"),
			dataIndex: "projectType",
			fixed: !isRTL ? "left" : undefined,
			width: 150,
			render: (projectType) => (
				<Tag
					className="text-capitalize"
					color={projectTypeTagColor[projectType]}
				>
					{trans(projectType)}
				</Tag>
			),
		},
		{
			title: trans("Status"),
			dataIndex: "projectStatus",
			width: 150,
			render: (projectStatus) => (
				<Tag
					className="text-capitalize"
					color={projectStatusTagColor[projectStatus]}
				>
					{trans(projectStatus)}
				</Tag>
			),
		},
		{
			title: trans("Address"),
			dataIndex: "address",
			width: 150,
			render: (address) => <span>{address ? address : "- - - - -"}</span>,
		},
		{
			title: trans("Actions"),
			width: 150,
			fixed: !isRTL ? "right" : undefined,
			render: ({ id }) => (
				<Actions
					poiId={id}
					canAddTask={create}
					canEdit={edit}
					canDelete={canDelete}
					type="projectSetup"
				/>
			),
		},
	];
	useEffect(() => {
		return () => setcurrentPOIId(null);
	}, [setcurrentPOIId]);

	return (
		<>
			<Helmet>
				<title>Project Setup</title>
				<meta name="description" content="projectsetup" />
			</Helmet>

			<BreadCrumb
				title={trans("Project Setup")}
				add={create ? trans("Add new project setup") : null}
				onClick={() => navigate("/setup/project-setup-control")}
			/>
			<ProjectsetupHeader setCurrentPage={setCurrentPage} />
			{ListPOISdata?.data?.length === 0 && searchQuery === "" && (
				<div
					style={{
						height: "calc(100vh - 130px)",
						display: "flex",
						alignItems: "center",
						justifyContent: "center",
						flexDirection: "column",
					}}
				>
					<img
						src={`${process.env.PUBLIC_URL}/assets/New/Randoms/EmptyTable.svg`}
						alt="empty"
						style={{ marginBottom: "30px" }}
					/>
					<p
						style={{ marginBottom: "4px", fontSize: "16px", fontWeight: "500" }}
					>
						{trans("No Construction Projects Created Yet")}
					</p>
					<span
						style={{
							color: "#00000099",
							fontSize: "14px",
							marginBottom: "30px",
						}}
					>
						{trans("Create your first one now!")}
					</span>
					<Button
						text={trans("Create New Project Setup")}
						type={"primary"}
						onClick={() => navigate("/setup/project-setup-control")}
					/>
				</div>
			)}
			<div className="bg-white-rounded-top mt-3 table-parent">
				<AntdTable
					columns={POIsColumn}
					loading={isLoading}
					dataSource={ListPOISdata?.data || []}
					pageSize={limit}
					totalItems={ListPOISdata?.totalResults || 0} // Total count for pagination
					currentPage={currentPage}
					onPageChange={(page) => setCurrentPage(page)}
					onLimitChange={(newLimit) => {
						setLimit(newLimit);
						setCurrentPage(1);
					}}
					onTableChange={handleTableChange}
				/>
			</div>
			<ProjectsetupForm />
		</>
	);
}
